import convert from 'convert-units';

import { measurementType, unitsMapping } from './MeasurementEnums';

export const measurementOptions = [
  { value: unitsMapping['kg/cm'], label: 'Metric (kg/ meters)' },
  { value: unitsMapping['lb/ftin'], label: 'Imperial (lb/ feet)' },
];

export const measurementOptionsWithoutUnit = [
  { value: unitsMapping['lb/ftin'], label: 'Imperial' },
  { value: unitsMapping['kg/cm'], label: 'Metric' },
];

const cmToInches = (cm: number) => cm / 2.54;
export const cmToFt = (cm: number) => Math.floor(cmToInches(cm) / 12);
export const cmToIn = (cm: number, digit?: number) =>
  Number((cmToInches(cm) % 12).toFixed(digit ?? 2));

const ftToCm = (feet: number) => feet * 30.48;
const inToCm = (inch: number) => inch * 2.54;
const convertToCm = (feet: number, inch: number) => ftToCm(feet) + inToCm(inch);

export const unitsOptions = [
  {
    unit: 'kg',
    type: measurementType.weight,
    convert: (weight: number) => convert(weight).from('lb').to('kg'),
  },
  {
    unit: 'lb',
    type: measurementType.weight,
    convert: (weight: number) => convert(weight).from('kg').to('lb'),
  },
  {
    unit: 'cm',
    type: measurementType.height,
    convert: (feet: number, inch?: number) => convertToCm(feet, inch ?? 0),
  },
  {
    unit: 'ft',
    type: measurementType.height,
    convert: (cm: number) => cmToFt(cm),
  },
  {
    unit: 'in',
    type: measurementType.inch,
    convert: (cm: number) => cmToIn(cm),
  },
];

export const measurementTasks = ['functional_reach'];
